import s from './DealsByCompanies.scss'
import { TabContent } from './TabContent'
import { Tabs } from 'components/ideal-core-ui'
import { toActiveClosedCompanies } from './serializers'
import { sortClientsByAwarded } from 'utils/helpers'

const DealsByCompanies = ({ dealsByCompany, dealAwardedCompany }) => {
  const companies = toActiveClosedCompanies(
    sortClientsByAwarded(dealsByCompany, dealAwardedCompany)
  )
  return (
    <Tabs
      className={s.tabsWrapper}
      contentClassName={s.contentClassName}
      activeTabKey="active"
      tabs={[
        {
          key: 'active',
          label: 'Active',
          value: <TabContent companies={companies.active} dealAwardedCompany={dealAwardedCompany} />
        },
        {
          key: 'closed',
          label: 'Closed',
          value: <TabContent companies={companies.closed} dealAwardedCompany={dealAwardedCompany} />
        }
      ]}
    />
  )
}

export default DealsByCompanies
